// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_math = require("rescript/lib/js/js_math.js");
var MM_parser = require("../mm-utils/MM_parser.bs.js");
var Caml_array = require("rescript/lib/js/caml_array.js");
var MM_context = require("../mm-utils/MM_context.bs.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Belt_MapString = require("rescript/lib/js/belt_MapString.js");
var Expln_React_Row = require("@expln/utils/src/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Modal = require("@expln/utils/src/main/react-components/Expln_React_Modal.bs.js");
var Expln_React_Column = require("@expln/utils/src/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("@expln/utils/src/main/Expln_React_common.bs.js");
var MM_wrk_search_asrt = require("../worker/MM_wrk_search_asrt.bs.js");
var Paper = require("@mui/material/Paper").default;
var Expln_utils_promise = require("@expln/utils/src/main/Expln_utils_promise.bs.js");
var Button = require("@mui/material/Button").default;
var Select = require("@mui/material/Select").default;
var Divider = require("@mui/material/Divider").default;
var Checkbox = require("@mui/material/Checkbox").default;
var MenuItem = require("@mui/material/MenuItem").default;
var TextField = require("@mui/material/TextField").default;
var InputLabel = require("@mui/material/InputLabel").default;
var Pagination = require("@mui/material/Pagination").default;
var FormControl = require("@mui/material/FormControl").default;

function makeInitialState(frms, initialTyp) {
  if (Belt_MapString.size(frms) === 0) {
    throw {
          RE_EXN_ID: MM_parser.MmException,
          _1: {
            msg: "Cannot search assertions when frms are empty."
          },
          Error: new Error()
        };
  }
  var allTypes = [];
  Belt_MapString.forEach(frms, (function (param, frm) {
          var typ = Caml_array.get(frm.frame.asrt, 0);
          if (!allTypes.includes(typ)) {
            allTypes.push(typ);
            return ;
          }
          
        }));
  return {
          label: "",
          allTypes: allTypes,
          typ: Belt_Option.getWithDefault(Belt_Option.map(initialTyp, (function (iniTyp) {
                      if (allTypes.includes(iniTyp)) {
                        return iniTyp;
                      } else {
                        return Caml_array.get(allTypes, 0);
                      }
                    })), Caml_array.get(allTypes, 0)),
          patternStr: "",
          patternErr: undefined,
          results: undefined,
          resultsForRender: undefined,
          resultsPerPage: 10,
          resultsMaxPage: 1,
          resultsPage: 1,
          checkedResultsIdx: []
        };
}

function setResults(st, results, ctx, frms) {
  var maxPage = Js_math.ceil_int(results.length / st.resultsPerPage);
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: st.patternStr,
          patternErr: st.patternErr,
          results: results,
          resultsForRender: results.map(function (result) {
                var frm = Belt_MapString.get(frms, result.asrtLabel);
                if (frm !== undefined) {
                  return React.createElement(Paper, {
                              style: {
                                padding: "3px"
                              },
                              children: React.createElement(Expln_React_Column.make, {
                                    children: null
                                  }, frm.hypsE.map(function (hyp, i) {
                                        return React.createElement(React.Fragment, {
                                                    children: null,
                                                    key: String(i)
                                                  }, hyp.label + ": " + MM_context.frmIntsToStrExn(ctx, frm.frame, hyp.expr), React.createElement(Divider, {}));
                                      }), result.asrtLabel + ": " + MM_context.frmIntsToStrExn(ctx, frm.frame, frm.frame.asrt))
                            });
                } else {
                  return "Cannot find assertion '" + result.asrtLabel + "'";
                }
              }),
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: maxPage,
          resultsPage: 1,
          checkedResultsIdx: []
        };
}

function setPage(st, page) {
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: st.patternStr,
          patternErr: st.patternErr,
          results: st.results,
          resultsForRender: st.resultsForRender,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: Math.max(0, Math.min(st.resultsMaxPage, page)),
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function setLabel(st, label) {
  return {
          label: label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: st.patternStr,
          patternErr: st.patternErr,
          results: st.results,
          resultsForRender: st.resultsForRender,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function setType(st, typ) {
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: typ,
          patternStr: st.patternStr,
          patternErr: st.patternErr,
          results: st.results,
          resultsForRender: st.resultsForRender,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function setPatternStr(st, patternStr) {
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: patternStr,
          patternErr: st.patternErr,
          results: st.results,
          resultsForRender: st.resultsForRender,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function setPatternErr(st, patternErr) {
  return {
          label: st.label,
          allTypes: st.allTypes,
          typ: st.typ,
          patternStr: st.patternStr,
          patternErr: patternErr,
          results: st.results,
          resultsForRender: st.resultsForRender,
          resultsPerPage: st.resultsPerPage,
          resultsMaxPage: st.resultsMaxPage,
          resultsPage: st.resultsPage,
          checkedResultsIdx: st.checkedResultsIdx
        };
}

function toggleResultChecked(st, idx) {
  if (st.checkedResultsIdx.includes(idx)) {
    return {
            label: st.label,
            allTypes: st.allTypes,
            typ: st.typ,
            patternStr: st.patternStr,
            patternErr: st.patternErr,
            results: st.results,
            resultsForRender: st.resultsForRender,
            resultsPerPage: st.resultsPerPage,
            resultsMaxPage: st.resultsMaxPage,
            resultsPage: st.resultsPage,
            checkedResultsIdx: st.checkedResultsIdx.filter(function (i) {
                  return i !== idx;
                })
          };
  } else {
    return {
            label: st.label,
            allTypes: st.allTypes,
            typ: st.typ,
            patternStr: st.patternStr,
            patternErr: st.patternErr,
            results: st.results,
            resultsForRender: st.resultsForRender,
            resultsPerPage: st.resultsPerPage,
            resultsMaxPage: st.resultsMaxPage,
            resultsPage: st.resultsPage,
            checkedResultsIdx: st.checkedResultsIdx.concat([idx])
          };
  }
}

function MM_cmp_search_asrt(Props) {
  var modalRef = Props.modalRef;
  var preCtxVer = Props.preCtxVer;
  var preCtx = Props.preCtx;
  var parenStr = Props.parenStr;
  var varsText = Props.varsText;
  var disjText = Props.disjText;
  var hyps = Props.hyps;
  var wrkCtx = Props.wrkCtx;
  var frms = Props.frms;
  var initialTyp = Props.initialTyp;
  var onTypChange = Props.onTypChange;
  var onCanceled = Props.onCanceled;
  var onResultsSelected = Props.onResultsSelected;
  var match = React.useState(function () {
        return makeInitialState(frms, initialTyp);
      });
  var setState = match[1];
  var state = match[0];
  var actLabelChange = function (str) {
    Curry._1(setState, (function (__x) {
            return setLabel(__x, str);
          }));
  };
  var actTypeChange = function (newTypeStr) {
    Curry._1(setState, (function (__x) {
            return setType(__x, MM_context.ctxSymToIntExn(wrkCtx, newTypeStr));
          }));
  };
  var actPatternChange = function (newPatternStr) {
    Curry._1(setState, (function (__x) {
            return setPatternStr(__x, newPatternStr);
          }));
  };
  var rndError = function (msgOpt) {
    if (msgOpt !== undefined) {
      return React.createElement("pre", {
                  style: {
                    color: "red"
                  }
                }, msgOpt);
    } else {
      return null;
    }
  };
  var rndPattern = function (param) {
    return React.createElement(TextField, {
                value: state.patternStr,
                label: "Pattern",
                size: "small",
                style: {
                  width: "300px"
                },
                onChange: (function (param) {
                    return Expln_React_common.evt2str(actPatternChange, param);
                  }),
                autoFocus: true
              });
  };
  var rndLabel = function (param) {
    return React.createElement(TextField, {
                value: state.label,
                label: "Label",
                size: "small",
                style: {
                  width: "100px"
                },
                onChange: (function (param) {
                    return Expln_React_common.evt2str(actLabelChange, param);
                  })
              });
  };
  var rndTyp = function (param) {
    return React.createElement(FormControl, {
                size: "small",
                children: null
              }, React.createElement(InputLabel, {
                    id: "asrt-type-select-label",
                    children: "Type"
                  }), React.createElement(Select, {
                    labelId: "asrt-type-select-label",
                    label: "Type",
                    value: MM_context.ctxIntToSymExn(wrkCtx, state.typ),
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(actTypeChange, param);
                      }),
                    children: state.allTypes.map(function (typI) {
                          var typStr = MM_context.ctxIntToSymExn(wrkCtx, typI);
                          return React.createElement(MenuItem, {
                                      value: typStr,
                                      children: typStr,
                                      key: typStr
                                    });
                        })
                  }));
  };
  var rndFilters = function (param) {
    return React.createElement(Expln_React_Column.make, {
                children: null
              }, React.createElement(Expln_React_Row.make, {
                    children: null
                  }, rndLabel(undefined), rndTyp(undefined), rndPattern(undefined), React.createElement(Button, {
                        onClick: (function (param) {
                            Curry._1(onTypChange, state.typ);
                            var incorrectSymbol = MM_parser.getSpaceSeparatedValuesAsArray(state.patternStr).find(function (sym) {
                                  return !MM_context.isConst(wrkCtx, sym);
                                });
                            if (incorrectSymbol !== undefined) {
                              return Curry._1(setState, (function (__x) {
                                            return setPatternErr(__x, "'" + incorrectSymbol + "' - is not a constant.");
                                          }));
                            } else {
                              Curry._1(setState, (function (__x) {
                                      return setPatternErr(__x, undefined);
                                    }));
                              Expln_utils_promise.promiseMap(Expln_React_Modal.openModal(modalRef, (function (param) {
                                          return MM_react_common.rndProgress("Searching", 0);
                                        })), (function (modalId) {
                                      return Expln_utils_promise.promiseMap(MM_wrk_search_asrt.searchAssertions(preCtxVer, preCtx, parenStr, varsText, disjText, hyps, state.label, state.typ, MM_context.ctxStrToIntsExn(wrkCtx, state.patternStr), (function (pct) {
                                                        Expln_React_Modal.updateModal(modalRef, modalId, (function (param) {
                                                                return MM_react_common.rndProgress("Searching", pct);
                                                              }));
                                                      })), (function (found) {
                                                    Expln_React_Modal.closeModal(modalRef, modalId);
                                                    Curry._1(setState, (function (__x) {
                                                            return setResults(__x, found, wrkCtx, frms);
                                                          }));
                                                  }));
                                    }));
                              return ;
                            }
                          }),
                        variant: "contained",
                        children: "Search"
                      }), React.createElement(Button, {
                        onClick: (function (param) {
                            Curry._1(onCanceled, undefined);
                          }),
                        children: "Cancel"
                      })), rndError(state.patternErr));
  };
  var rndPagination = function (totalNumOfResults) {
    if (state.resultsPerPage < totalNumOfResults) {
      return React.createElement(Pagination, {
                  count: state.resultsMaxPage,
                  page: state.resultsPage,
                  onChange: (function (param, newPage) {
                      Curry._1(setState, (function (__x) {
                              return setPage(__x, newPage);
                            }));
                    })
                });
    } else {
      return null;
    }
  };
  var rndResultButtons = function (param) {
    return React.createElement(Expln_React_Row.make, {
                children: null
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        var results = state.results;
                        if (results !== undefined) {
                          return Curry._1(onResultsSelected, results.filter(function (res, i) {
                                          return state.checkedResultsIdx.includes(i);
                                        }));
                        }
                        
                      }),
                    variant: "contained",
                    disabled: state.checkedResultsIdx.length === 0,
                    children: "Choose selected"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(onCanceled, undefined);
                      }),
                    children: "Cancel"
                  }));
  };
  var rndResults = function (param) {
    var resultsForRender = state.resultsForRender;
    if (resultsForRender === undefined) {
      return null;
    }
    var items = [];
    var minI = Math.imul(state.resultsPage - 1 | 0, state.resultsPerPage);
    var maxI = Math.min((minI + state.resultsPerPage | 0) - 1 | 0, resultsForRender.length - 1 | 0);
    for(var i = minI; i <= maxI; ++i){
      var resultForRender = Caml_array.get(resultsForRender, i);
      items.push(resultForRender);
    }
    var totalNumOfResults = resultsForRender.length;
    return React.createElement(Expln_React_Column.make, {
                children: null
              }, rndPagination(totalNumOfResults), items.map(function (item, i) {
                    var resIdx = minI + i | 0;
                    return React.createElement("table", {
                                key: String(resIdx)
                              }, React.createElement("tbody", undefined, React.createElement("tr", undefined, React.createElement("td", undefined, React.createElement(Checkbox, {
                                                checked: state.checkedResultsIdx.includes(resIdx),
                                                onChange: (function (param) {
                                                    Curry._1(setState, (function (__x) {
                                                            return toggleResultChecked(__x, resIdx);
                                                          }));
                                                  })
                                              })), React.createElement("td", undefined, item))));
                  }), rndPagination(totalNumOfResults), rndResultButtons(undefined));
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: React.createElement(Expln_React_Column.make, {
                    spacing: 1,
                    children: null
                  }, rndFilters(undefined), rndResults(undefined))
            });
}

var make = MM_cmp_search_asrt;

exports.makeInitialState = makeInitialState;
exports.setResults = setResults;
exports.setPage = setPage;
exports.setLabel = setLabel;
exports.setType = setType;
exports.setPatternStr = setPatternStr;
exports.setPatternErr = setPatternErr;
exports.toggleResultChecked = toggleResultChecked;
exports.make = make;
/* react Not a pure module */
